import { useCallback, useContext, useEffect, useState } from 'react';
/* import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton'; */
import EDCaptionedValue from '../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import AttributeDisplayText from '../../../../../Components/Attributes/AttributeDisplayText/AttributeDisplayText';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { GravplatsQuery_node_TEDGAGrav as IGravplatsNode } from './Queries/_QueryTypes/GravplatsQuery';
/* import EDIcon from '../../../../../BaseComponents/Icon/EDIcon'; */
import clientAvenyModel from '../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { IAttributeInfo } from '../../../../../Model/avenyModelUtils';
import { BusinessDataFormContext } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  MASKED_VALUE_TEXT,
  getMaskedFromCurrentValues,
} from '../../../_Common/Hooks/useAttributeValues';
import BildViewer from './BildViewer';
import BildVäljare from './BildVäljare';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { useSparaGravplatsBild } from './Utils/useSparaGravplatsBild';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
/* import { useIsSmallScreen } from '../../../../../Hooks/useFullscreenView'; */

const GravModel: IClientBusinessModel =
  clientAvenyModel.GA.BusinessModels.GAGrav;

const FotoKort: React.FC<{
  nodeData: IGravplatsNode | null | undefined;
  attrInfoBildAndrad: IAttributeInfo;
  attrInfoBild: IAttributeInfo;
}> = ({ nodeData, attrInfoBildAndrad, attrInfoBild }) => {
  const formContext = useContext(BusinessDataFormContext);
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  const { sparaBild, loading } = useSparaGravplatsBild(
    nodeData?.AktuellGravID ?? 0,
    activeDatabase ?? ''
  );

  const masked = getMaskedFromCurrentValues(
    formContext?.formState.currentValues,
    'Blob.BildAndrad',
    attrInfoBild.attribute
  );

  const [uploadedBlobId, setUploadedBlobId] = useState<string | undefined>();
  const [isWaitingForImageLoad, setIsWaitingForImageLoad] = useState(false);
  const currentBlobId = uploadedBlobId ?? nodeData?._Associations?.Blob?.BILD;

  const handleSave = useCallback(
    async (file: File) => {
      const newBlobId = await sparaBild(file);
      if (newBlobId) {
        setIsWaitingForImageLoad(true);
        setUploadedBlobId(newBlobId);
      }
    },
    [sparaBild]
  );

  const handleImageLoaded = useCallback(() => {
    setIsWaitingForImageLoad(false);
  }, []);

  useEffect(() => {
    if (!isWaitingForImageLoad) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsWaitingForImageLoad(false);
    }, 8000);

    return () => window.clearTimeout(timeoutId);
  }, [isWaitingForImageLoad]);

  const photoLoading = loading || isWaitingForImageLoad;

  /* const isSmallScreen = useIsSmallScreen(); */
  return (
    <ObjektVyKort
      className="position-relative"
      backgroundColor={'white'}
      caption="Foto"
      button={() => (
        <BildVäljare
          onSave={handleSave}
          dialogTitle="Granska gravplatsfoto"
          disabled={masked || photoLoading}
        />
      )}
      /*   button={() => (
        <>
          <EDButton
            flat
            label={isSmallScreen ? undefined : 'TA FOTO'}
            tooltip="Ta foto"
            size="small"
            icon={
              <EDIcon
                iconType="add_circle"
                marginRight={0.5}
                color={'primary'}
                size="small"
              />
            }
          />
          <EDButton
            flat
            label={isSmallScreen ? undefined : 'LADDA UPP'}
            tooltip="Ladda upp foto"
            size="small"
            icon={
              <EDIcon
                iconType="cloud_upload"
                marginRight={0.5}
                color={'primary'}
                size="small"
              />
            }
          />
          <EDButton
            flat
            label={isSmallScreen ? undefined : 'ROTERA'}
            tooltip="Rotera foto"
            size="small"
            icon={
              <EDIcon
                iconType="rotate_90_degrees_cw"
                marginRight={0.5}
                color={'primary'}
                size="small"
              />
            }
          />
        </>
      )} */
    >
      {photoLoading && <EDAvenyProgress overlay />}

      {masked ? (
        <EDCaptionedValue
          label="Gravplatsfoto"
          name="Gravplatsfoto"
          size="large"
        >
          <EDTypography>{MASKED_VALUE_TEXT}</EDTypography>
        </EDCaptionedValue>
      ) : currentBlobId ? (
        <div>
          <BildViewer
            blobId={currentBlobId}
            alt="Gravplatsfoto"
            style={{ height: '200px', objectFit: 'cover' }}
            dialogTitle="Gravplatsfoto"
            onImageLoad={handleImageLoaded}
            onImageError={handleImageLoaded}
          />
        </div>
      ) : (
        <EDCaptionedValue
          label="Gravplatsfoto"
          name="Gravplatsfoto"
          size="large"
        >
          <EDTypography>Foto saknas</EDTypography>
        </EDCaptionedValue>
      )}

      <EDCaptionedValue
        label="Senast uppdaterad"
        name={attrInfoBildAndrad.attribute.AttributeName}
        size="large"
      >
        <AttributeDisplayText
          value={nodeData?._Associations?.Blob?.BildAndrad}
          attributeModel={attrInfoBildAndrad.attribute}
          collection={GravModel}
          forceText
        />
      </EDCaptionedValue>
    </ObjektVyKort>
  );
};

export default FotoKort;
